export default function CheckedList({ items = [], size = "default" }) {
  const sizeClass = size === "large" ? "text-base" : "text-sm";

  return (
    <ul className={`${sizeClass} text-slate-600 space-y-1`}>
      {items.map((item) => (
        <li key={item} className="flex items-start gap-2">
          <span className="text-[#FF5744]">✓</span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
